
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28.106 4.832C26.772 3.735 21.314.322 16 7.114 10.685.322 5.227 3.735 3.893 4.832c-2.334 1.92-5.134 6.586 0 13.326 2.188 2.872 6.495 6.122 11.434 10.157.392.32.955.32 1.346 0 4.938-4.034 9.246-7.284 11.434-10.157 5.134-6.74 2.334-11.407 0-13.326h0z","stroke":"#CFCFCF","stroke-width":"2"}})])
          )
        }
      }
    